import { render, staticRenderFns } from "./WidgetCargas.vue?vue&type=template&id=0c9fe2bc&lang=pug"
import script from "./WidgetCargas.vue?vue&type=script&lang=js"
export * from "./WidgetCargas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports